import { useState, useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import bannerpc from "../../assets/Banner Site.webp";
import bannermob from "../../assets/Banner Cell.webp";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";

export function Bannerpromo() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  const items = [
    {
      imagebanner: isMobile ? bannermob : bannerpc,
      linkbanner: "/",
    },
  ];

  useEffect(() => {
    const bannerTimer = setTimeout(() => {
      setShowBanner(true);
    }, 2500);
    return () => clearTimeout(bannerTimer);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  }, [items.length]);

  const prevSlide = useCallback(() => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + items.length) % items.length
    );
  }, [items.length]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!isHovering && showBanner) nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [isHovering, nextSlide, showBanner]);

  if (!showBanner) {
    return (
      <Box className="relative w-full overflow-hidden" style={{ height: isMobile ? 250 : 400 }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ bgcolor: "grey.400" }}
          animation="wave"
        />
      </Box>
    );
  }

  return (
    <div
      className={`relative w-full overflow-hidden mt-2 sm:mt-16 md:mt-16 h-[250px] sm:h-[300px] md:h-[180px] lg:h-[240px] xl:h-[306px] 2xl:h-[450px]`}
      onMouseEnter={() => !isMobile && setIsHovering(true)}
      onMouseLeave={() => !isMobile && setIsHovering(false)}
    >
      <div
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            className="relative min-w-full flex-shrink-0 flex items-center justify-center"
          >
            <div className="absolute inset-0">
              <Link to={item.linkbanner} aria-label="Promoção">
                <img
                  src={item.imagebanner}
                  className="w-screen object-contain object-center"
                  alt="Banner promocional"
                />
              </Link>
            </div>
          </div>
        ))}
      </div>

      {(isHovering || isMobile) && items.length > 1 && (
        <>
          <button
            className="absolute left-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 focus:outline-none focus:ring-2 focus:ring-white"
            onClick={prevSlide}
            aria-label="Slide anterior"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <button
            className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 focus:outline-none focus:ring-2 focus:ring-white"
            onClick={nextSlide}
            aria-label="Próximo slide"
          >
            <ChevronRight className="h-4 w-4" />
          </button>
        </>
      )}

      {items.length > 1 && (
        <div className="absolute bottom-2 left-1/2 flex -translate-x-1/2 space-x-1">
          {items.map((_, index) => (
            <button
              key={index}
              className={`h-1.5 rounded-full transition-all ${
                currentIndex === index ? "bg-white w-6" : "bg-white/50 w-3"
              }`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Ir para slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
